const source = 'https://ih1.redbubble.net/image.';
const dimensions = '/st,extra_large,375x375.png';

export { source, dimensions };
